<script setup>
import axios from "axios";

import { ref } from "vue";
import AssignWorkNoSave from "../../../AssignWorkNoSave.vue";

const props = defineProps({
    selectedFeatures: {
        type: Array,
        required: true
    },
    users: {
        type: Object,
        required: true
    },
    teams: {
        type: Array,
        required: true
    },
    permissions: {
        type: Object,
        required: true
    },
    setBulkAssign: {
        type: Function,
        required: false,
        default:() =>{}
    },
    bulkUpdated: {
        type: Function,
        required: false,
        default:() =>{}
    }
});

const step = ref(1);
const assignList = ref([]);
const loading = ref(false);
const removeExisting = ref(false);

const next = () => {
    step.value++;
};
const closeModal = () => {
    props.setBulkAssign(false);
};
const assignUsers = () => {
    loading.value = true;

    axios
        .post("/api/works/assign", {
            assignList: assignList.value,
            selectedFeatures: props.selectedFeatures,
            removeExisting: removeExisting.value,
        })
        .then((response) => {
            loading.value = false;
            props.bulkUpdated();
        })
        .catch((error) => {
            alert("Error: " + error);
            props.setBulkAssign(false);
        });
};
</script>

<template>
    <div
        style="max-height: 95%"
        class="fixed top-0 inset-x-0 px-4 py-4 sm:inset-0 sm:flex sm:items-center sm:justify-center z-10"
    >
        <div class="fixed inset-0 transition-opacity" style="z-index: -1">
            <div class="absolute inset-0 bg-slate-500 opacity-75"></div>
        </div>

        <div
            class="bg-white rounded-lg shadow-xl transform transition-all sm:max-w-xl sm:w-full lg:w-1/2 z-10"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-headline"
        >
            <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div class="w-full">
                    <div v-if="step === 1" class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                        <h3 class="text-lg leading-6 font-medium text-slate-900" id="modal-headline">
                            Bulk Assign the Selected Works
                        </h3>
                        <div class="mt-2">
                            <p class="leading-5 text-slate-600">
                                Click the plus button below to assign Users to all
                                <strong>{{ props.selectedFeatures.length }}</strong> Selected Works.
                            </p>
                        </div>
                        <div class="mt-4 w-full">
                            <assign-work-no-save
                                :users="users"
                                :teams="teams"
                                :permissions="permissions"
                                :assignList="assignList"
                            />
                        </div>
                        <div class="w-full flex md:flex-no-wrap flex-wrap justify-center text-center py-4"></div>

                        <fieldset class="space-y-5 pt-2 px-1">
                            <legend class="sr-only">Notifications</legend>
                            <div class="relative flex items-start">
                                <div class="flex items-center h-6">
                                    <input
                                        v-model="removeExisting"
                                        id="removeExisting"
                                        aria-describedby="removeExisting-description"
                                        name="removeExisting"
                                        type="checkbox"
                                        class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-slate-300 rounded"
                                    />
                                </div>
                                <div class="ml-3 text-sm">
                                    <label for="removeExisting" class="font-medium text-slate-700"
                                        >Replace Existing Assignee's</label
                                    >
                                    <p id="removeExisting-description" class="text-slate-500">
                                        This will remove any existing assignee's on the Selected Works before updating.
                                    </p>
                                </div>
                            </div>
                        </fieldset>
                    </div>
                </div>
            </div>
            <div class="bg-slate-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
                    <button
                        @click="closeModal()"
                        type="button"
                        class="mr-2 inline-flex justify-center w-full rounded-lg border border-slate-300 px-4 py-2 bg-slate-100 text-base leading-6 font-semibold text-slate-700 shadow-sm hover:text-slate-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                    >
                        Cancel
                    </button>
                    <button
                        v-if="!loading"
                        @click="assignUsers()"
                        type="button"
                        class="whitespace-nowrap inline-flex justify-center w-full rounded-lg border border-transparent px-4 py-2 bg-blue-600 text-base leading-6 font-semibold text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:border-red-700 focus:shadow-outline-red transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                    >
                        Assign Work
                    </button>
                    <button
                        v-else
                        disabled
                        type="button"
                        class="whitespace-nowrap inline-flex justify-center w-full rounded-lg border border-transparent px-4 py-2 bg-blue-600 text-base leading-6 font-semibold text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:border-red-700 focus:shadow-outline-red transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                    >
                        Assigning...
                    </button>
                </span>
            </div>
        </div>
    </div>
</template>


